export const local_routes = {
  'cities':'/cities',
  'locations':'/cities',
  'presentations':'/presentations',
  'channels':'/channels',
  'teams':'/groups', // workspace version of channels (formerly teams)
  'events':'/events',
  'eventcalendar':'/events/calendar',
  'categories':'/categories',
  'users':'/users',
  'managecity':'/managecity', // public website
  'managechannel':'/managechannel', // public website
  'manageteam':'/managegroup', // workspace version of channels
  'manageworkspace':'/manageteam', // workspace - confusing because we are changing what team means a few times
  'managepechakucha':'/managepechakucha',
  'pkcreation':'/pkcreation',
  'accountsettings':'/accountsettings',
  'pklist':'/pklist',
  'pkcreatehome':'/pkcreate',
  'about':'/about',
  'manageevent':'/manageevent',
  //'managechannelevent':'/managechannelevent',
  //'manageteamevent':'/manageteamevent', // workspace version of channels
  'myevents':'/myevents',
  'groups':'/groups',
  'chats':'/chats',
  'sendresetpasswordemail':'/sendresetpasswordemail',
  'resetpassword':'/resetpassword',
  //'workspace':'/workspace' // prepend to workspace pages
  'workspace':'/team', // prepend to workspace pages
  'not_found':'/404',
  'error':'/error',
  'register':'/register',
  'login':'/login',
  'help':'https://pechakucha.zendesk.com/hc/en-us/sections/360008365352-PK-Create-Team-Subscription-Help-Desk', // new tab
  'forschools':'https://go.pechakucha.com/for-schools',
  'forbusiness':'https://go.pechakucha.com/for-businesses',
  'hostanevent':'https://go.pechakucha.com/host-an-event',
  'usecases':'https://go.pechakucha.com/use-cases',
  'hubspotpricing':'https://go.pechakucha.com/pricing',
  'pricing':'/pricing',
  'pkpricing':'/pricing',
  'shop':'https://pechakucha.me',
  'waf_contest':'https://www.worldarchitecturefestival.com/isolation-transformed-competition',
  'pkcreate_help':'https://pechakucha.zendesk.com/hc/en-us/categories/360002876531-PechaKucha-com-PK-Create-',
  'pkmaker':'/pkmaker',
  'jobs':'/jobs'
};

export const feature_names = {
  'workspace': 'team',
  'Workspace': 'Team',
  'Team': 'Group',
  'team': 'group'
}